/**
 * Valida que una cédula uruguaya (8 dígitos) coincida con su dígito verificador.
 * @param {string} cedula - Cadena de 8 caracteres numéricos (sin puntos ni guiones).
 * @returns {boolean} - true si la cédula es válida, false en caso contrario.
 */
export function validarCedulaUruguaya(cedula) {
  if (!/^[0-9]{8}$/.test(cedula)) {
    return false;
  }

  const digitos = cedula.split('').map(Number);
  const multiplicadores = [2, 9, 8, 7, 6, 3, 4];

  let suma = 0;
  for (let i = 0; i < multiplicadores.length; i++) {
    suma += digitos[i] * multiplicadores[i];
  }

  const resto = suma % 10;
  const digitoVerificador = resto === 0 ? 0 : 10 - resto;
  return digitoVerificador === digitos[7];
}
